import { IColunasSettingsUser } from "@app/shared/utils/validar_settings_user";

export const COLUNAS_DEFAULT_MODULE_SYSADMIN_PRECIFICACAO = [
  {
    module: 'SERVICO_PRECIFICACAO',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'codigo'
      },
      {
        active: true,
        removable: false,
        field: 'nome'
      },
      {
        active: true,
        removable: true,
        field: 'frequencia'
      },
      {
        active: true,
        removable: true,
        field: 'dias_vigencia'
      },
      {
        active: true,
        removable: true,
        field: 'dias_carencia'
      },
      {
        active: true,
        removable: true,
        field: 'v_adicional'
      },
      {
        active: true,
        removable: true,
        field: 'v_recorrencia'
      },

      {
        active: true,
        removable: true,
        field: 'v_aquisicao'
      }
    ]
  },
  {
    module: 'PRODUTO_PRECIFICACAO',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'codigo'
      },
      {
        active: true,
        removable: false,
        field: 'nome'
      },
      {
        active: true,
        removable: true,
        field: 'identificador_prod'
      },
      {
        active: true,
        removable: true,
        field: 'tipo'
      },
      {
        active: true,
        removable: true,
        field: 'qtd'
      },
      {
        active: true,
        removable: true,
        field: 'qtd_disponivel'
      },
      {
        active: true,
        removable: true,
        field: 'valor'
      }
    ]
  },
  { module: 'TERMO_PRECIFICACAO', colunas: [] },
  {
    module: 'PLANO_PRECIFICACAO',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'codigo'
      },
      {
        active: true,
        removable: false,
        field: 'nome'
      },
      {
        active: true,
        removable: true,
        field: 'application.name'
      },
      {
        active: true,
        removable: true,
        field: 'v_aquisicao'
      },
      {
        active: true,
        removable: true,
        field: 'v_recorrencia'
      },
      {
        active: true,
        removable: true,
        field: 'v_total_produtos'
      },
      {
        active: true,
        removable: true,
        field: 'v_total_servicos'
      },
      {
        active: true,
        removable: true,
        field: 'customizado'
      }
    ]
  },
  {
    module: 'CONTRATO_PRECIFICACAO',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'codigo'
      },
      {
        active: true,
        removable: false,
        field: 'nome'
      },
      {
        active: true,
        removable: true,
        field: 'domain.name'
      },
      {
        active: true,
        removable: true,
        field: 'plano.nome'
      },
      {
        active: true,
        removable: true,
        field: 'v_aquisicao'
      },
      {
        active: true,
        removable: true,
        field: 'v_recorrente'
      },
      {
        active: true,
        removable: true,
        field: 'v_total_produots'
      },
      {
        active: true,
        removable: true,
        field: 'v_total_servicos'
      },
      {
        active: true,
        removable: true,
        field: 'valor_total_contrato'
      },
      {
        active: true,
        removable: true,
        field: 'customizado'
      }
    ]
  }
] as IColunasSettingsUser[];
